<button
  [ngClass]="{
    'disabled': isDisabled,
    'medium-size': size == 'medium',
    'small-size': size == 'small'
}"
  (click)="handleClick()"
>
  <div class="text">
    <ng-content></ng-content>
  </div>
</button>
